// Copyright (c) Ping. All rights reserved.

/**
 * Decodes a URL-safe base64 VAPID public key for `pushManager.subscribe`.
 * Returns an `ArrayBuffer`-backed `Uint8Array` (not the generic
 * `Uint8Array<ArrayBufferLike>`) so it satisfies the DOM `BufferSource` type
 * that `applicationServerKey` requires under TS 5.7+.
 */
export function urlBase64ToUint8Array(base64String: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const output = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; ++i) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
}

export function readVapidPublicKey(): string | undefined {
  const key = import.meta.env.VITE_WEBPUSH_VAPID_PUBLIC_KEY;
  if (typeof key !== 'string') {
    return undefined;
  }
  const trimmed = key.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}
